import Button from 'react-bootstrap/Button';
import { useNavigate, useLocation } from 'react-router';
import logoMajesticResortsImg from '../assets/logo_majestic_resorts.svg';
import logoMajesticHorizontalImg from '../assets/logo_majestic_horizontal.svg';
import logoMajesticHorizontalImgWhite from '../assets/logo_majestic_horizontal_white.svg';


const pathLogoHorizontalList = [
  '/Hotels',
  '/Checking',
  '/Booking',
  '/DocumentFront',
  '/DocumentCapture',
  '/DocumentReverseCapture',
  '/DocumentFrontCapture',
  '/DocumentPreview',
  '/DocumentationReview',
  '/Residence',
  '/ContractSignature',
  '/BookingMotive',
  '/ImportantRemember',
  '/Finished',
  '/DocumentationEdit',
  '/DocumentReverse',
];

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  let logoWhite = false;

  if (location.pathname === '/') {
    return (
      <div className="app__header flex-grow-1 d-flex align-items-md-end align-items-center justify-content-center">
        <img src={logoMajesticResortsImg} alt="logoMajesticResorts" />
      </div>
    );
  }

  if (pathLogoHorizontalList.includes(location.pathname)) {
    if (['/DocumentReverseCapture','/DocumentFrontCapture'].includes(location.pathname)) {
      logoWhite = true;
    }

    return (
      <div className={`app__header text-center py-3 ${location.pathname === '/Checking' ? 'position-absolute start-0 end-0 top-0 z-1' : ''}`}>
        <Button
          variant=""
          onClick={() => navigate('/')}
          className="btn bg-transparent border-0 shadow-none"
        >
          <img src={logoWhite ? logoMajesticHorizontalImgWhite : logoMajesticHorizontalImg} alt="logoMajesticHorizontal" />
        </Button>
      </div>
    );
  }
}

export default Header;
